import React, { useState } from "react";
import PropTypes from "prop-types";

//
import { Modal, Button, Form, Spinner } from "react-bootstrap";

//
import { editPortfolio } from "../../redux/features/portfolio/actions";
import { updatePortfolioName } from "../../redux/features/portfolio/slice";

//
import { Formik } from "formik";
import * as yup from "yup";
import { connect } from "react-redux";

const schema = yup.object().shape({
  name: yup.string().required(),
});

function EditPortfolioModal({
  show,
  setShow,
  activePortfolio,
  updatePortfolioName,
}) {
  const [loading, setLoading] = useState(false);

  /**
   * Edit Portfolio
   * change portfolio name from list
   * change portfolio name form active
   * close modal
   */
  const edit_portfolio = (e) => {
    // start loading
    setLoading(true);

    // set variable
    let id = activePortfolio.id;
    let content = e;

    // request
    editPortfolio({ id, content }).then((res) => {
      if (res) {
        setLoading(false);

        updatePortfolioName(res);

        setShow(false);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      id="portfolio-modal"
    >
      <Modal.Header closeButton>
        <h5>Edit Portofolio</h5>
      </Modal.Header>
      <Modal.Body>
        <Formik
          validationSchema={schema}
          onSubmit={edit_portfolio}
          initialValues={{
            name: activePortfolio.name || "",
          }}
          className="portfolio-form"
        >
          {({ handleSubmit, handleChange, touched, errors, values }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group className="form-group">
                <Form.Label>Portfolio Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Write here..."
                  className="form-control"
                  onChange={handleChange}
                  autoComplete="off"
                  value={values.name}
                  isInvalid={touched.name && !!errors.name}
                />
              </Form.Group>

              <div className="actions">
                <div className="back" onClick={() => setShow(false)}>
                  Back
                </div>

                <Button variant="info" type="submit" size="lg">
                  Create One
                  {loading && (
                    <div className="spinner-holder">
                      <Spinner animation="border" variant="white" size="sm" />
                    </div>
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

EditPortfolioModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  activePortfolio: PropTypes.object.isRequired,
  updatePortfolioName: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  updatePortfolioName,
};

const mapStateToProps = (state) => ({
  activePortfolio: state.portfolioReducer.activePortfolio,
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPortfolioModal);
